"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberInputWithArrows = void 0;
var _react = _interopRequireDefault(require("react"));
var _NumberInput = require("../number-input/NumberInput");
var _numberInputWithArrowsModule = _interopRequireDefault(require("./number-input-with-arrows.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _caretDown = require("../../../assets/icons/caret-down.svg");
var _caretUp = require("../../../assets/icons/caret-up.svg");
var NumberInputWithArrows = function NumberInputWithArrows(props) {
  var _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    onChange = props.onChange,
    min = props.min,
    max = props.max;
  var increaseValue = function increaseValue() {
    var newValue = value + 1;
    if (max !== undefined && newValue > max) return;
    onChange(newValue, true);
  };
  var decreaseValue = function decreaseValue() {
    var newValue = props.value - 1;
    if (min !== undefined && newValue < min) return;
    onChange(newValue, true);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _numberInputWithArrowsModule.default['number-input-with-arrows']
  }, /*#__PURE__*/_react.default.createElement(_NumberInput.NumberInput, Object.assign({}, props, {
    className: (0, _classnames.default)(_numberInputWithArrowsModule.default['number-input-with-arrows__input'], props.className)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _numberInputWithArrowsModule.default['number-input-with-arrows__controls']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _numberInputWithArrowsModule.default['number-input-with-arrows__icon'],
    role: "button",
    onClick: increaseValue,
    "data-testid": "increase-value"
  }, /*#__PURE__*/_react.default.createElement(_caretUp.ReactComponent, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: _numberInputWithArrowsModule.default['number-input-with-arrows__icon'],
    role: "button",
    onClick: decreaseValue,
    "data-testid": "decrease-value"
  }, /*#__PURE__*/_react.default.createElement(_caretDown.ReactComponent, null))));
};
exports.NumberInputWithArrows = NumberInputWithArrows;